import { FormProvider, useForm } from 'react-hook-form';
import { Button, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import Modal from 'src/components/customModal';
import modals from 'src/constants/modals';
import { styledMainTitle } from 'src/components/InviteModal/styles';
import { ActionButtons } from 'src/layouts/main/styles';
import { handleCloseModal } from 'src/utils/propertyHelpers';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { RHFTextField } from 'src/components';
import searchCompany from 'src/api/company/search-company';
import { dispatch } from 'src/redux/store';
import { openModal } from 'src/redux/slices/modal';
import { AddCompanyForm } from './types';
import { validationSchema } from './validation';

const Content = () => {
	const { enqueueSnackbar } = useSnackbar();
	const [isLoading, setIsLoading] = useState(false);
	const form = useForm<AddCompanyForm>({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (data: AddCompanyForm) => {
		try {
			setIsLoading(true);

			const company = await searchCompany({ regNum: data.registrationNumber });

			if (!company.isFromHousingApi) {
				enqueueSnackbar('Company already exists in our system', { variant: 'error' });

				return;
			}

			dispatch(openModal({ name: modals.verifyNewCompany, payload: company }));
		} catch (e) {
			if (e instanceof Error) enqueueSnackbar(e.message, { variant: 'error' });
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<FormProvider {...form}>
			<form
				onSubmit={(e) => {
					e.stopPropagation();
					form.handleSubmit(handleSubmit)(e);
				}}
			>
				<Typography sx={styledMainTitle} pt={0}>
					ADD COMPANY
				</Typography>
				<Typography sx={styledMainTitle} pt={0}>
					To add a new company, please enter its registration number from Companies House.
				</Typography>
				<RHFTextField name='registrationNumber' label='Registration number' />
				<ActionButtons mt={'20px'}>
					<Button variant='outlined' size='large' fullWidth onClick={handleCloseModal}>
						Cancel
					</Button>
					<LoadingButton variant='contained' size='large' fullWidth type='submit' loading={isLoading}>
						Submit
					</LoadingButton>
				</ActionButtons>
			</form>
		</FormProvider>
	);
};

const AddCompanyModal = () => (
	<Modal name={modals.addCompany} cardSx={{ overflow: 'visible', maxWidth: '550px' }}>
		<Content />
	</Modal>
);

export default AddCompanyModal;
